<template>
    <div>
        <div class="flex items-center bg-gray-200 dark:bg-dark-900">
            <button
                v-for="aba in mapa"
                :key="aba.name"
                class="p-2 text-xs"
                :class="{ 'bg-gray-50 dark:bg-dark-800 border-b-4 border-primary-700': aba == abaSelecionada }"
                @click="scrollPara(aba)"
            >
                {{ aba.name }}
            </button>
        </div>

        <div class="my-2 px-2">
            <div>
                <input
                    class="block w-full p-2 text-sm bg-gray-50 rounded-md dark:bg-dark-900"
                    v-model="search"
                    :placeholder="__('Pesquisar emoji...')"
                />
            </div>
        </div>

        <div class="overflow-auto mb-2 px-2" style="height: 150px">
            <div v-for="aba in mapa" :key="aba.name" :id="aba.id">
                <div class="text-gray-600 dark:text-gray-800 text-xs">{{ aba.name }}</div>

                <div v-for="(emoji, index) in aba.emojis" :key="index" class="inline-block">
                    <button
                        v-if="!emoji.skinTones"
                        class="text-2xl p-1 focs:outline-none"
                        @click="escolherEmoji(emoji.emoji)"
                    >
                        {{ emoji.emoji }}
                    </button>

                    <alo-dropdown trigger="longclick" v-if="emoji.skinTones && emoji.skinTones.length > 0">
                        <template v-slot:default="{ open: open }">
                            <button
                                class="text-2xl p-1 focus:outline-none"
                                @click="() => (open ? null : escolherEmoji(emoji.emoji))"
                            >
                                {{ emoji.emoji }}
                            </button>
                        </template>

                        <template #menu>
                            <div class="flex items-center px-2">
                                <button
                                    class="text-2xl p-1 rounded hover:bg-gray-100 focus:outline-none"
                                    @click="escolherEmoji(emoji.emoji)"
                                    close-dropdown
                                >
                                    {{ emoji.emoji }}
                                </button>

                                <div class="w-px h-10 bg-gray-300 mx-2"></div>

                                <button
                                    class="text-2xl p-1 rounded hover:bg-gray-100 focus:outline-none"
                                    v-for="emojiVar in emoji.skinTones"
                                    :key="emojiVar"
                                    @click="escolherEmoji(emojiVar)"
                                    close-dropdown
                                >
                                    {{ emojiVar }}
                                </button>
                            </div>
                        </template>
                    </alo-dropdown>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mapa from '@Shared/Emoji'

// for (let i = 0; i < 200; i++) {
//     mapa[0].emojis.push({ name: [__('Sorriso')], emoji: '😀' })
// }

export default {
    data() {
        return {
            search: '',
            abaSelecionada: mapa[0],
        }
    },
    computed: {
        mapa() {
            if (!this.search) return mapa

            return mapa
                .map((seção) => {
                    return {
                        ...seção,
                        emojis: seção.emojis.filter((emoji) => {
                            return emoji.name.find((name) => name.indexOf(this.search.toLowerCase()) !== -1)
                        }),
                    }
                })
                .filter((seção) => {
                    return seção.emojis.length > 0
                })
        },
    },
    methods: {
        scrollPara(aba) {
            this.abaSelecionada = aba

            this.$el.querySelector('#' + aba.id).scrollIntoView({ behavior: 'smooth' })
        },

        /**
         * Emite evento informando o editor que o usuário escolheu um emoji
         *
         * @param {string} emoji Codepoint do emoji selecionado.
         */
        escolherEmoji(emoji) {
            this.$emit('pick', emoji)
        },

        /**
         * Limpa a pesquisa e resultados mostrados
         *
         * @return {void}
         */
        limpar() {
            this.search = ''
        },
    },
}
</script>